var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"energy-lines"},_vm._l((_vm.displayData),function(item){return _c('AnimatedLine',{key:`${item.id}-${item.arrowDirection}`,attrs:{"display-data-item":item,"width":_vm.canvasSize.width,"height":_vm.canvasSize.height,"is-line-active":!!item.arrowDirection}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }